/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import { PrivateRoutes } from './PrivateRoutes';
import { Logout, AuthPage, authUserSelector } from '../modules/auth';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { MasterInit } from '../../_metronic/layout/MasterInit';
import { PickerLayout } from '../modules/picking/components/PickerLayout';
import { CartCodeInput } from '../modules/picking/components/CartCodeInput';
import { OrderPickingScreen } from '../modules/picking/components/OrderPickingScreen';
import { ExternalOrdersLayout } from '../modules/external-orders/components/ExternalOrdersLayout';
import { ExternalOrdersPage } from '../pages/b2b/ExternalOrdersPage';

const Routes: FC = () => {
  const authUser = useSelector(authUserSelector, shallowEqual);
  const isPicker = !!authUser?.groups?.find((group) => group.name === 'Picker');
  const isExternalOrdersUser = !!authUser?.groups?.find(
    (group) => group.name === 'ExternalOrders'
  );

  return (
    <>
      <Switch>
        {authUser ? (
          isPicker ? (
            <PickerLayout>
              <Switch>
                <Route exact path="/picking" component={CartCodeInput} />
                <Route
                  path="/picking/:cartCode"
                  component={OrderPickingScreen}
                />
                <Redirect from="/" to="/picking" />
                <Redirect to="/picking" />
              </Switch>
            </PickerLayout>
          ) : isExternalOrdersUser ? (
            <ExternalOrdersLayout>
              <Switch>
                <Route path="/external-orders" component={ExternalOrdersPage} />
                <Redirect from="/" to="/external-orders" />
                <Redirect to="/external-orders" />
              </Switch>
            </ExternalOrdersLayout>
          ) : (
            <MasterLayout>
              <PrivateRoutes />
            </MasterLayout>
          )
        ) : (
          <>
            <Route>
              <AuthPage />
            </Route>
            <Redirect to="/auth/login" />
          </>
        )}
        <Route path="/logout" component={Logout} />
        <Route path="/error" component={ErrorsPage} />
      </Switch>
      <MasterInit />
    </>
  );
};

export { Routes };
